import React, { useState } from 'react';
import axios from 'axios';
import { useAuthHeader } from 'react-auth-kit';
import { Modal, Container, Row, Col, ButtonToolbar, Button, Form, Card } from 'react-bootstrap';
import { mexicoCityToday } from '../../../../utils/dateTime';

function DefaultModal(props) {
    const today = mexicoCityToday();
    const apiUrl = process.env.REACT_APP_URL;
    const authHeader = useAuthHeader();

    const [cleaningData, setCleaningData] = useState({
        inventory_id: '',
        service_date: today,
        service_time: '10:00',
        responsible_user_id: '',
        supervisor_user_id: '',
        total_cost: 0,
        is_completed: false,
        notes: ''
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (field, value) => {
        setCleaningData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        try {
            // Combine date and time for service_datetime
            const service_datetime = `${cleaningData.service_date} ${cleaningData.service_time}:00`;

            const payload = {
                inventory_id: cleaningData.inventory_id,
                service_datetime: service_datetime,
                responsible_user_id: cleaningData.responsible_user_id,
                supervisor_user_id: cleaningData.supervisor_user_id || null,
                total_cost: parseFloat(cleaningData.total_cost) || 0,
                is_completed: cleaningData.is_completed,
                notes: cleaningData.notes || null
            };

            const response = await axios.post(`${apiUrl}/services/cleaning`, payload, {
                headers: {
                    Authorization: authHeader()
                }
            });

            // alert('Limpieza agregada exitosamente');
            props.setData();
            props.onHide();

            // Reset form
            setCleaningData({
                inventory_id: '',
                service_date: today,
                service_time: '10:00',
                responsible_user_id: '',
                supervisor_user_id: '',
                total_cost: 0,
                is_completed: false,
                notes: ''
            });

        } catch (error) {
            console.error('Error creating cleaning:', error);
            alert('Error al crear el registro de limpieza');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Agregar Limpieza
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <Container>
                    <Form onSubmit={handleSubmit}>
                        {/* Basic Information */}
                        <Card className="mb-3">
                            <Card.Header>
                                <h6 className="mb-0">Información Básica</h6>
                            </Card.Header>
                            <Card.Body>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Unidad *</Form.Label>
                                        <Form.Select
                                            value={cleaningData.inventory_id}
                                            onChange={(e) => handleChange('inventory_id', e.target.value)}
                                            required
                                        >
                                            <option value="">Seleccionar unidad...</option>
                                            {props.inventoryOptions.map((unit) => (
                                                <option key={unit.id} value={unit.id}>
                                                    {unit.name || unit.inventory_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} md={6}>
                                        <Form.Check
                                            type="checkbox"
                                            label="Completado"
                                            checked={cleaningData.is_completed}
                                            onChange={(e) => handleChange('is_completed', e.target.checked)}
                                            className="mt-4"
                                        />
                                    </Form.Group>
                                </Row>

                                <Row className="mb-3">
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Fecha del Servicio *</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={cleaningData.service_date}
                                            onChange={(e) => handleChange('service_date', e.target.value)}
                                            required
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Hora del Servicio</Form.Label>
                                        <Form.Control
                                            type="time"
                                            value={cleaningData.service_time}
                                            onChange={(e) => handleChange('service_time', e.target.value)}
                                        />
                                    </Form.Group>
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Staff Assignment */}
                        <Card className="mb-3">
                            <Card.Header>
                                <h6 className="mb-0">Asignación de Personal</h6>
                            </Card.Header>
                            <Card.Body>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Responsable *</Form.Label>
                                        <Form.Select
                                            value={cleaningData.responsible_user_id}
                                            onChange={(e) => handleChange('responsible_user_id', e.target.value)}
                                            required
                                        >
                                            <option value="">Seleccionar responsable...</option>
                                            {props.userOptions.map((user) => (
                                                <option key={user.id} value={user.id}>
                                                    {user.full_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Supervisor</Form.Label>
                                        <Form.Select
                                            value={cleaningData.supervisor_user_id}
                                            onChange={(e) => handleChange('supervisor_user_id', e.target.value)}
                                        >
                                            <option value="">Seleccionar supervisor...</option>
                                            {props.userOptions.map((user) => (
                                                <option key={user.id} value={user.id}>
                                                    {user.full_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Cost Information */}
                        <Card className="mb-3">
                            <Card.Header>
                                <h6 className="mb-0">Información de Costos</h6>
                            </Card.Header>
                            <Card.Body>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Costo Total</Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            value={cleaningData.total_cost}
                                            onChange={(e) => handleChange('total_cost', e.target.value)}
                                            placeholder="0.00"
                                        />
                                    </Form.Group>
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Additional Notes */}
                        <Card className="mb-3">
                            <Card.Header>
                                <h6 className="mb-0">Notas Adicionales</h6>
                            </Card.Header>
                            <Card.Body>
                                <Form.Group>
                                    <Form.Label>Notas</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={cleaningData.notes}
                                        onChange={(e) => handleChange('notes', e.target.value)}
                                        placeholder="Cualquier información adicional relevante..."
                                    />
                                </Form.Group>
                            </Card.Body>
                        </Card>

                        <div className="text-end">
                            <Button variant="secondary" onClick={props.onHide} className="me-2">
                                Cancelar
                            </Button>
                            <Button type="submit" variant="primary" disabled={loading}>
                                {loading ? 'Guardando...' : 'Guardar Limpieza'}
                            </Button>
                        </div>
                    </Form>
                </Container>
            </Modal.Body>
        </Modal>
    );
}

class ModalWithGrid extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = { modalShow: false };
    }

    render() {
        let add_new_cleaning = () => {
            this.props.setData();
            this.setState({ modalShow: false });
        }

        return (
            <ButtonToolbar>
                <Button
                    variant="primary"
                    onClick={() => this.setState({ modalShow: true })}
                >
                    Agregar Limpieza
                </Button>
                <DefaultModal
                    show={this.state.modalShow}
                    onHide={add_new_cleaning}
                    setData={this.props.setData}
                    inventoryOptions={this.props.inventoryOptions}
                    userOptions={this.props.userOptions}
                />
            </ButtonToolbar>
        );
    }
}

export default ModalWithGrid;
